import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-section flex justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode("input", {
          ref: "fileInput",
          type: "file",
          accept: ".csv",
          class: "hidden",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
        }, null, 544),
        _createVNode(_component_LpButton, {
          textColor: "white",
          title: "Upload file",
          iconLeft: "upload-white",
          small: "",
          customClass: "w-full md:w-50",
          disabled: _ctx.isLoading,
          onClick: _ctx.onClickUpload
        }, null, 8, ["disabled", "onClick"])
      ])
    ])
  ]))
}